<template>
  <div>
    <vx-card class="w-full mb-6">
      <vs-table ref="questionTable" stripe class="vs-con-loading__container" single @selected="handleSelectedQuestion" pagination :max-items="itemsPerPage" search :data="questions" v-scroll-to="'#questionInfoCard'">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">
          <div class="flex flex-wrap-reverse items-center">
            <!-- ADD NEW -->
            <div class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="showDetailsCard" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ questions.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : questions.length }} of {{ questions.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <template slot="thead">
          <vs-th sort-key="text">Text</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="modifiedBy">Modified By</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="question" :key="indextr" v-for="(question, indextr) in data">

            <vs-td :data="data[indextr].text">
              {{ question.text }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedOn">
              {{ question.modifiedOn.replace("T", " ").split('.')[0] }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedBy">
              {{ question.modifiedBy }}
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <vx-card id="questionInfoCard" ref="questionInfo" class="mb-6" :title="questionCardTitle" v-show="!isInfoHidden">
      <div class="vx-row pb-3">
        <div class="vx-col sm:w-1/2 w-full mb-2">
          <label>Text</label>
          <vs-textarea autocomplete="off" onClick="this.select();" class="w-full" v-model="formData.text" />
        </div>
      </div>

      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" :disabled="isDisabled" @click.prevent="saveEditQuestion" ref="saveEditButton">Save</vs-button>
          <vs-button color="danger" v-show="formData.id" class="mr-5 mb-2 vs-con-loading__container" @click.prevent="deleteQuestion" ref="deleteButton">Delete</vs-button>
          <vs-button color="warning" type="border" class="mb-2" v-scroll-to="'#questionInfoCard'" @click="cancelAdd">Cancel</vs-button>
        </div>
      </div>
    </vx-card>

  </div>
</template>

<script>
  export default {
    components: {
      
    },
    data() {
      return {
        loadingColor:'#fff',
        selected: [],
        itemsPerPage: 10,
        isMounted: false,
        isInfoHidden: true,
        questions: [],
        formData: {
          id: 0,
          text: ""
        },
        mode: "",
        questionCardTitle: "",
        counterDanger: false
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.questionTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.text);
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.text = "";
        this.mode = "";
        this.isInfoHidden = true;
        this.errors.clear();
      },
      cancelAdd() {
        this.initValues();
        this.isInfoHidden = true;
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadData() {
        const self = this;
        self.showLoadingOnElement("questionTable", 1, "corners");

        var onSuccess = function (response) {
          self.questions = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.questionTable.$el);
        };

        self.$ajaxGet(self, "PracticalQuestion/GetAllQuestions", onSuccess, onFinally);
      },
      showDetailsCard(){
        var self = this;
        self.errors.clear();
        self.initValues();
        self.isInfoHidden = false;
        self.mode = "Add New";
        self.questionCardTitle = "Add Question";
      },
      handleSelectedQuestion(question) {
        var self = this;
        self.isInfoHidden = false;
        self.mode = "Update";
        self.questionCardTitle = "Edit Question";
        self.formData.id = question.id;
        self.formData.text = question.text;
      },
      saveEditQuestion() {
        var self = this;
        self.$validator.validateAll().then(result => {
          if (result) {
            self.showLoadingOnElement("saveEditButton", 0.45, "material");

            var onSuccess = response => {
              self.formData.id = response.data;
              self.saveData();
              if(self.mode != "Add New"){
                self.isInfoHidden = true;
                self.initValues();
              }else
                self.defaultButtonsHidden = true;

              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Question Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            };
            var onFinally = function () {
              self.$vs.loading.close(self.$refs.saveEditButton.$el);
            };
            self.$ajaxPost(self, "PracticalQuestion/AddEdit", self.formData, onSuccess, onFinally);
          } else {
            self.$vs.notify({
              title:'Attention',
              color: "warning",
              text: self.$validator.errors.items[0].msg,
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-info'
            });
          }
        });
      },
      deleteQuestion() {
        var self = this;
        self.showLoadingOnElement("deleteButton", 0.45, "material");

        var onSuccess = response => {
          self.saveData();
          self.initValues();
          self.errors.clear();
          self.isInfoHidden = true;
          self.scrollToNavbar();
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Question Deleted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-trash'
          });
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.deleteButton.$el);
        };

        self.$ajaxDelete(self, "PracticalQuestion/Delete/" + self.formData.id, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
    },
    mounted() {
      var self = this;
      self.loadData();
      self.isMounted = true;
    },
  }

</script>